/* Trackingparameters uit de adresbalk halen.

   Klik je van de ene site naar de andere binnen dezelfde Analytics-property, dan plakt
   Google er `_gl=...` achter om de bezoeker te herkennen. Dat hoort niemand te zien, en
   het maakt gedeelde links lelijk. We halen die parameters weg zodra de tracking ze
   gelezen heeft, met replaceState: de pagina herlaadt niet en de meting blijft dus staan.

   Bewust níet weggehaald: utm_*, gclid en dergelijke. Die voeden de campagnerapporten en
   worden door Analytics pas gelezen bij de eerste pageview, en dat kan door de
   cookiemelding later zijn dan het opkuisen. */

const teVerwijderen = ['_gl', '_ga'];
const maxWachttijd = 3000;
const stapje = 200;

function heeftParameters() {
    const params = new URL(window.location.href).searchParams;
    return teVerwijderen.some((naam) => params.has(naam));
}

function trackingIsGeladen() {
    return Boolean(
        window.google_tag_manager ||
        window.gtag ||
        (Array.isArray(window.dataLayer) && window.dataLayer.length)
    );
}

function ruimOp() {
    const url = new URL(window.location.href);
    teVerwijderen.forEach((naam) => url.searchParams.delete(naam));

    const query = url.searchParams.toString();
    window.history.replaceState({}, document.title, url.pathname + (query ? `?${query}` : '') + url.hash);
}

function wachtEnRuimOp() {
    if (!heeftParameters()) return;

    let gewacht = 0;
    const timer = setInterval(() => {
        gewacht += stapje;
        // Zodra de tracking er is mag het weg; staat ze uit (geen toestemming), dan na
        // de wachttijd alsnog, want dan wordt er toch niets gemeten.
        if (trackingIsGeladen() || gewacht >= maxWachttijd) {
            clearInterval(timer);
            ruimOp();
        }
    }, stapje);
}

if (document.readyState === 'complete') {
    wachtEnRuimOp();
} else {
    window.addEventListener('load', wachtEnRuimOp);
}
